import React from "react";
import { TableCell, TableRow, TableBody } from "@mui/material";
import { paginateArray } from "../helpers/paginateArray";

export default function EquipRows(props) {
  const visibleRows = React.useMemo(
    () => [...paginateArray(props.arry, props.page, 10)],
    [props.arry, props.page]
  );

  return (
    <TableBody>
      {visibleRows.map((row, idx) => (
        <TableRow
          key={idx}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          onClick={(event) => props.handleClick(event, row.id, props.tableName)}
        >
          <TableCell component="th" scope="row">
            {row.Name}
          </TableCell>
          <TableCell>{row.Type}</TableCell>
          {row.hasOwnProperty("Space") && <TableCell>{row.Space}</TableCell>}
        </TableRow>
      ))}

      {visibleRows.length < 10 && (
        <TableRow
          style={{
            height: 33 * (10 - visibleRows.length),
          }}
        >
          <TableCell colSpan={6} />
        </TableRow>
      )}
    </TableBody>
  );
}
